import styled from "styled-components";
import {Descriptions, Avatar, Button, Tag, Table, Typography, List, Select, Row} from "antd";
import {MinusCircleFilled, FileImageFilled} from "@ant-design/icons";

const {Text} = Typography;

export const DescriptionContainer = styled(Descriptions)`
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        margin-top: 12px;
        margin-bottom: 12px;

        .ant-descriptions-item {
            padding-bottom: 12px;
        }

        .ant-descriptions-item-label {
            font-weight: 600;
            padding-bottom: 4px;
            font-size: 13px;
        }

        .ant-descriptions-item-content {
            display: block;
            font-size: 14px;
            word-break: break-word;
        }

        .ant-descriptions-view {
            overflow-x: auto;
        }

        /* Force single column on mobile */
        .ant-descriptions-row {
            display: flex;
            flex-direction: column;
        }

        .ant-descriptions-item {
            width: 100% !important;
        }
    }
`;

export const OrderNumber = styled(Text)`
    font-weight: bold;

    @media (max-width: 768px) {
        font-size: 16px;
        display: block;
        margin-bottom: 8px;
    }
`;

export const MergedOrderStats = styled(Text)`
    font-weight: bold;
    float: left;

    @media (max-width: 768px) {
        float: none;
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
    }
`;

export const OrderTotalTime = styled(Text)`
    font-weight: bold;
    float: right;

    @media (max-width: 768px) {
        float: none;
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
    }
`;

export const TransferInfoContainer = styled.div`
    padding: 0 35px 35px;
    margin-top: 5px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;

    @media (max-width: 768px) {
        padding: 0 12px 12px;
        margin-bottom: 16px;
    }
`;

export const TransferLogList = styled(List)`
    .ant-list-item {
        padding: 6px 0;
    }
    .ant-list-item-meta-title {
        margin-bottom: 0px;
        font-weight: 300;
    }
    .ant-list-item-meta {
        margin-bottom: 0px;
    }

    @media (max-width: 768px) {
        .ant-list-item-meta-avatar {
            margin-right: 12px;
        }

        .ant-avatar {
            width: 40px;
            height: 40px;
        }

        .ant-list-item-meta-title {
            font-size: 14px;
        }

        .ant-list-item-meta-description {
            font-size: 13px;
        }
    }
`;

export const TransferDescription = styled.p`
    font-size: 12px;
    color: black;
`;

export const StepContainer = styled.div`
    position: relative;
    padding: 0 35px 35px;
    border: 1px solid #f0f0f0;
    margin-bottom: 30px;
    margin-top: 5px;
    .ant-steps-item-content {
        width: auto;
    }

    @media (max-width: 768px) {
        padding: 0 12px 12px;
        margin-bottom: 16px;

        .ant-steps-item-title {
            font-size: 13px;
        }

        .ant-steps-item-description {
            font-size: 12px;
        }
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    height: 350px;
    overflow: auto;
    border: 5px solid #aeff01;

    z-index: 10;
    position: relative;
    /*            ^^ */
    ${({mode}) =>
        mode == "fixed" &&
        `position:fixed;
        left: 105px;
        right:25px;
        bottom:40px;
        top:95px;
        width:inherit;
        height:inherit;`}

    @media (max-width: 768px) {
        height: 250px;
        border-width: 3px;

        ${({mode}) =>
            mode == "fixed" &&
            `left: 0;
            right: 0;
            bottom: 0;
            top: 60px;`}
    }
`;
export const MapTools = styled(Button)`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 5;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    svg {
        width: 1.5em;
        height: 1.5em;
        margin: 5px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;
`;

export const TableTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;

    @media (max-width: 768px) {
        margin: 12px 0;
        font-size: 1.1em !important;
    }
`;

export const TableOverflow = styled.div`
    width: 100%;
    overflow: auto;

    @media (max-width: 768px) {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 0 -16px;
        padding: 0 16px;

        table {
            min-width: 600px;
        }
    }
`;
export const LeftButton = styled(Button)`
    padding-right: 50px;
    padding-left: 50px;

    @media (max-width: 768px) {
        padding-right: 16px;
        padding-left: 16px;
        font-size: 13px;
        width: 100%;
        margin-right: 0 !important;
        margin-top: 0 !important;
    }
`;
export const MiddleButton = styled(Button)`
    margin-right: 20px;
    margin-left: 20px;

    @media (max-width: 768px) {
        margin-right: 0;
        margin-left: 0;
        font-size: 13px;
        width: 100%;
    }
`;
export const RightButton = styled(Button)`
    float: right;

    @media (max-width: 768px) {
        float: none;
        width: 100%;
        margin-top: 8px;
        font-size: 13px;
        height: auto;
        padding: 8px 16px;
    }
`;

export const AnnulmentButton = styled(Button)`
    display: ${props => (props.visible === "true" ? "none" : "block")};
    margin: auto;
    width: 90px;

    @media (max-width: 768px) {
        width: 100%;
        font-size: 12px;
        padding: 6px 12px;
        height: auto;
    }
`;
export const PassButton = styled(Button)`
    margin-top: 3px;
    margin-bottom: 10px;
    width: 90px;

    @media (max-width: 768px) {
        width: 100%;
        font-size: 12px;
        padding: 6px 12px;
        height: auto;
    }
`;

export const DetailTag = styled(Tag)`
    margin-bottom: 0.5rem;
    margin-left: 5px;

    @media (max-width: 768px) {
        font-size: 12px;
        padding: 2px 8px;
        margin-left: 4px;
        margin-bottom: 0.4rem;
    }
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: calc(100% - 70px);
    height: calc(100% - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffffbf;
    z-index: 999;
`;

export const OrderTable = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }

    @media (max-width: 768px) {
        .ant-table {
            font-size: 13px;
        }

        .ant-table-thead > tr > th {
            padding: 8px;
            font-size: 12px;
        }

        .ant-table-tbody > tr > td {
            padding: 8px;
            font-size: 13px;
        }

        /* Expanded row düzenlemeleri */
        .ant-table-expanded-row > .ant-table-cell {
            padding: 16px 12px !important;
            background-color: #f8f9fa;
        }

        .ant-table-expanded-row-fixed {
            margin: 0 !important;
        }

        /* Expand icon */
        .ant-table-row-expand-icon {
            width: 32px;
            height: 32px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            background: #f0f0f0;

            &:hover {
                background: #e0e0e0;
            }
        }

        /* Expanded content wrapper */
        .ant-table-expanded-row .ant-table-cell > * {
            width: 100%;
        }

        /* Expanded row içindeki ProductTable düzeltmesi */
        .ant-table-expanded-row {
            > .ant-table-cell {
                display: block !important;
            }

            .ant-table-wrapper {
                display: block !important;
                width: 100% !important;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
            }

            .ant-table {
                display: table !important;
                table-layout: fixed !important;
                width: 100% !important;
                min-width: 400px !important;
            }

            .ant-table table {
                display: table !important;
                width: 100% !important;
            }

            .ant-table-thead {
                display: table-header-group !important;
            }

            .ant-table-thead > tr {
                display: table-row !important;
            }

            .ant-table-thead > tr > th {
                display: table-cell !important;
                padding: 8px 6px !important;
                font-size: 11px !important;
                background: #fafafa !important;
                white-space: nowrap !important;
                border-bottom: 1px solid #e8e8e8 !important;
            }

            .ant-table-tbody {
                display: table-row-group !important;
            }

            .ant-table-tbody > tr {
                display: table-row !important;
                margin: 0 !important;
                border: none !important;
                box-shadow: none !important;
                border-radius: 0 !important;
                background: white !important;
            }

            .ant-table-tbody > tr > td {
                display: table-cell !important;
                padding: 10px 6px !important;
                font-size: 13px !important;
                border-bottom: 1px solid #f0f0f0 !important;
                white-space: normal !important;
                word-break: break-word !important;
            }

            .ant-table-tbody > tr > td::before {
                display: none !important;
                content: none !important;
            }

            /* Divider ve content styling */
            .ant-divider {
                margin: 12px 0 !important;
                font-size: 13px !important;
            }

            .ant-col {
                padding: 0 !important;
                width: 100% !important;
            }
        }
    }
`;

export const CancelButton = styled(Button)`
    margin-left: 8px;

    @media (max-width: 768px) {
        margin-left: 4px;
        font-size: 13px;
        padding: 4px 12px;
    }
`;

export const QueueModalContainer = styled.div`
    width: 600px;
    background-color: white;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const PrepModalContainer = styled.div`
    width: 600px;
    background-color: white;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const MinusCircleFilledIcon = styled(MinusCircleFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const FileImageFilledIcon = styled(FileImageFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const SelectField = styled(Select)`
    width: 100%;

    @media (max-width: 768px) {
        .ant-select-selector {
            font-size: 14px;
        }
    }
`;

export const PrepDetailContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        margin-top: 12px;
        margin-bottom: 12px;
    }
`;

export const MapStepRow = styled(Row)`
    @media screen and (max-width: 992px) {
        flex-direction: column-reverse;
    }

    @media (max-width: 768px) {
        margin: 0 !important;

        .ant-col {
            padding-left: 6px !important;
            padding-right: 6px !important;
        }
    }
`;
